<template>
  <div>
    <v-row>
      <v-col
        v-for="(file, attachmentKey) in orderedAttachments"
        :key="attachmentKey"
        cols="12"
        class="attachment-col"
      >
        <attachment-card
          :file="{ ...file, attachmentKey }"
          :show-delete-button="true"
          @viewAttachment="viewAttachment"
          @deleteAttachment="showDeleteModal"
          @show-modal="showAttachmentModelWithAttachmentType"
        ></attachment-card>
      </v-col>
    </v-row>
    <naj-confirmation
      :show-modal="deleteModalVisibility"
      color="error"
      :title="local.common.removeConfirmation"
      :message="removeMessage"
      :ok-btn-label="local.common.remove"
      :action-loading="deleteLoading"
      @ok="handleDeleteAttachment"
      @cancel="hideDeleteModal"
    ></naj-confirmation>
  </div>
</template>

<script>
import AttachmentCard from './attachment-card.vue';

import { createNamespacedHelpers } from 'vuex';
import { attachmentType } from '@/helpers/enum';
const { mapState, mapActions, mapGetters } = createNamespacedHelpers('BankruptcyModule');
export default {
  components: { AttachmentCard },
  props: {
    attachments: { required: true },
    attachmentTypes: { required: false },
  },
  data() {
    return {
      attachmentType,
      deleteLoading: false,
      deleteModalVisibility: false,
      requiredAttachments: [],
      selectedAttachmentId: -1,
    };
  },
  computed: {
    ...mapState({}),
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isEditMode',
    ]),
    filteredAttachments() {
      return (this.attachmentTypes || []).map((a) => {
        const isFound = !!this.attachments.find(b => b.typeId === a.id);
        return {
          ...a,
          isFound,
        };
      });
    },
    placeholders() {
      const attachments = this.filteredAttachments.filter(a => !a.isFound && (!a.isGlobal || a.isRequired));
      const data = {};
      attachments.map((a) => {
        data[a.id] = {
          ...a,
          isPlaceholder: true,
        };
      });
      return data;
    },
    attachmentsData() {
      return {
        ...this.placeholders,
        ...this.attachments,
      };
    },
    removeMessage() {
      return this.local.common.dynamicRemoveConfirmationMessage(this.local.attachments.attachment);
    },
    requestObjectKey() {
      return this.$route.params.objectKey;
    },
    orderedAttachments() {
      return _.orderBy(this.attachmentsData, 'isRequired', 'desc');
    },
  },
  methods: {
    ...mapActions(['getAttachmentURL', 'deleteAttachment']),
    showAttachmentModelWithAttachmentType(id) {
      this.$emit('show-attachment-modal', id);
    },
    viewAttachment({ file, attachmentKey }) {
      const attachment = {
        fileUrl: file.fileUrl,
        name: file.name,
        fileType: file.fileType,
        categoryName: file.categoryName,
        attachmentFile: file,
        attachmentKey,
      };
      attachment.fileUrl ? this.$emit('attachmentSelected', attachment)
        : this.getAttachmentURL({
          requestObjectKey: this.requestObjectKey,
          objectKey: file.objectKey,
        }).then((imageURL) => {
          attachment.fileUrl = imageURL;
          this.$emit('attachmentSelected', attachment);
        });
    },
    handleDeleteAttachment() {
      this.deleteLoading = true;
      this.deleteAttachment({
        requestObjectKey: this.requestObjectKey,
        objectKey: this.objectKey,
      })
        .then(() => {
          this.hideDeleteModal();
          this.$emit('deleteAttachment');
        })
        .finally(() => (this.deleteLoading = false));
    },
    hideDeleteModal() {
      this.attachmentKey = null;
      this.objectKey = null;
      this.deleteModalVisibility = false;
    },
    showDeleteModal({ attachmentKey, objectKey }) {
      this.attachmentKey = attachmentKey;
      this.objectKey = objectKey;
      this.deleteModalVisibility = true;
    },
    showAttachmentModal() {
      this.$emit('show-attachment-modal');
    },
  },

};
</script>

<style lang="scss" scoped>
.attachment-col {
  cursor: pointer;
  &:first-child {
    padding-top: 0px;
  }
  &:last-child {
    padding-bottom: 0px;
  }
}
</style>
